import {
  FlexBoxImageScaleView,
  FlexBoxView,
  getFlexNode,
} from '@play-co/timestep-core/flexbox';
import uiConfig from 'src/lib/ui/config';
import i18n from 'src/lib/i18n/i18n';
import animate from '@play-co/timestep-core/lib/animate';
import { animDuration, isPlatformGuest } from 'src/lib/utils';
import { ImageView, View } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import sounds from 'src/lib/sounds';
import ShopActionButton, { ShopActionType } from './ShopActionButton';
import { Minigame } from 'src/replicant/minigame';
import StateObserver from 'src/StateObserver';
import platform from '@play-co/gcinstant';
import { openGemsShopSequence, isGemsButtonDisabled } from '../shop/Helpers';

const ui = uiConfig.buruburu.menu;

export default class ShopMenu extends FlexBoxImageScaleView {
  constructor() {
    super(ui.menu);

    this.image.onInputStart = () => this.emit('Close');

    const { onSelect } = this;

    const row = this.addSubview(
      new FlexBoxView({ ...ui.menuRow, offsetY: 170 }),
    );

    row.addSubview(
      new ShopActionButton({
        type: 'energy',
        onSelect,
        isDisabled: !Minigame.getters(
          StateObserver.getState().user,
        ).areMinigamesAvailable(),
      }),
    );

    row.addSubview(
      new ShopActionButton({
        type: 'gems',
        onSelect,
        isDisabled: isGemsButtonDisabled(),
      }),
    );

    row.addSubview(new ShopActionButton({ type: 'coins', onSelect }));

    const closeHint = this.addSubview(new ImageView(ui.closeHintBg));
    closeHint.canHandleEvents(false, true);
    getFlexNode(closeHint).updateStyle({ marginTop: 200 });
    closeHint.addSubview(
      new LangBitmapFontTextView({
        ...ui.closeHintText,
        localeText: () => i18n('footer.tapToClose'),
        width: closeHint.style.width,
        height: closeHint.style.height,
      }),
    );
  }

  fadeIn(superview: View) {
    animate(this)
      .clear()
      .now(() =>
        this.updateOpts({
          superview,
          visible: true,
          opacity: 0,
          offsetY: 100,
        }),
      )
      .then({ opacity: 1, offsetY: 0 }, animDuration, animate.easeOut);
  }

  fadeOut() {
    animate(this)
      .clear()
      .then({ opacity: 0, offsetY: 100 }, animDuration, animate.easeOut)
      .then(() => {
        this.removeFromSuperview();
      });
  }

  private onSelect = async (type: ShopActionType) => {
    sounds.sfx.play('ok');

    switch (type) {
      case 'coins': {
        await openPopupPromise('popupCoinsShop', {});

        this.emit('Close');
        return;
      }
      case 'energy': {
        await openPopupPromise('popupEnergyShop', {});

        this.emit('Close');
        return;
      }
      case 'gems': {
        // If IAP enabled just show gems shop or alternative way to get gems if IAP disabled
        await openGemsShopSequence('gem_shop_icon');

        this.emit('Close');
        return;
      }
    }
  };
}
